import { FormControl, FormGroup } from '@angular/forms';
import { LocationEDWSummary } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Location EDW Summary`,
  DATE_LABEL: $localize`Completed Date`,
  ROUTE_LABEL: $localize`Route`,
};

export const FILE_NAME = 'Location-EDW-Summary';

export const PDF_REPORT = {
  NAME: $localize`EDW Location Summary`,
  HEADER: {
    SITE_CODE: $localize`Site Code` + ':',
    SITE_NAME: $localize`Site Name` + ':',
    DATE: $localize`Date` + ':',
  },
  FOOTER: {
    TOTAL: $localize`Total`.toUpperCase() + ':',
  },
  COLUMNS: [
    $localize`Route Id`.toUpperCase(),
    $localize`Driver`.toUpperCase(),
    $localize`Total Stops`.toUpperCase(),
    $localize`Total Pkgs`.toUpperCase(),
    $localize`# Total Stops with EDW`.toUpperCase(),
    $localize`# Total Stops EDW Met`.toUpperCase(),
    $localize`% Total Stops EDW Met`.toUpperCase(),
    $localize`# Committed Stops with EDW`.toUpperCase(),
    $localize`# Committed Stops EDW Met`.toUpperCase(),
    $localize`% Committed Stops EDW Met`.toUpperCase(),
  ],
  DATA_FIELDS: [
    'routeId',
    'driver',
    'totalStops',
    'totalPkgs',
    'numOfTotalStopswithEDW',
    'numOfTotalStopsEDWMet',
    'percentOfTotalStopsEDWMet',
    'numOfCommittedStopswithEDW',
    'numOfCommittedStopsEDWMet',
    'percentOfCommittedStopsEDWMet',
  ] as (keyof LocationEDWSummary)[],
};

export const CSV_FILE_COLUMN_HEADING = [
  `Route Id`,
  `Driver`,
  `Total Stops`,
  `Total Pkgs`,
  `# Total Stops with EDW`,
  `# Total Stops EDW Met`,
  `% Total Stops EDW Met`,
  `# Committed Stops with EDW`,
  `# Committed Stops EDW Met`,
  `% Committed Stops EDW Met`,
];

type LocationEdwFormField = {
  date: FormControl<Date>;
  routes: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type LocationEdwFormGroup = FormGroup<LocationEdwFormField> | null;
